import {
	SET_FEUILLETAGE,
	CLEAR_FEUILLETAGE,
} from "../actions/feuilletageActions"

// Une liste figée par domaine : `{ source, ids }`. `ids` vide = feuilletage
// inerte (on est entré sur la fiche sans passer par une liste).
const listeVide = { source: "", ids: [] }

const initialState = {
	dep: listeVide,
	ate: listeVide,
	loc: listeVide,
}

export default function feuilletageReducer(state = initialState, action) {
	switch (action.type) {
		case SET_FEUILLETAGE:
			return {
				...state,
				[action.payload.domaine]: {
					source: action.payload.source,
					ids: action.payload.ids,
				},
			}
		case CLEAR_FEUILLETAGE:
			return { ...state, [action.payload.domaine]: listeVide }
		default:
			return state
	}
}
